import { AppRouteProps } from "@harea/component";
import React from "react";
import { createDocumentRoutes } from "view/create/createDocumentRoutes";
import { editDocumentRoutes } from "view/edit/editDocumentRoutes";

const DocumentContainer = React.lazy(
    () => import("./container/DocumentContainer")
);
const EmployeeListContainer = React.lazy(
    () => import("view/employee/container/EmployeeListContainer")
);
const EmployeeDocumentsContainer = React.lazy(
    () => import("view/employee/container/EmployeeDocumentsContainer")
);
const TemplateListContainer = React.lazy(
    () => import("view/template/container/TemplateListContainer")
);
const DocumentDetailsContainer = React.lazy(
    () => import("view/document-template-details/container/DocumentDetailsContainer")
);

export const DocumentRoutes: Array<AppRouteProps> = [
    {
        path: "documents",
        title: "Harea.Document.Title",
        element: <DocumentContainer />,
        roles: ["DOCUMENT_TEMPLATE", "DOCUMENT_MANAGE", "DOCUMENT_DOWNLOAD"],
        children: [
            {
                path: "templates",
                element: <TemplateListContainer />,
                children: [
                    ...createDocumentRoutes,
                    ...editDocumentRoutes,
                    {
                        path: ":id/details",
                        title: "Harea.Document.Template.Details",
                        element: <DocumentDetailsContainer />,
                    },
                ],
            },
            {
                path: "personal",
                element: <EmployeeListContainer />,
                children: [
                    {
                        path: ":userId/documents",
                        element: <EmployeeDocumentsContainer />,
                    },
                ]
            },
        ],
    },
];
